import AdditionalFilters from './AdditionalFilters.vue';

export { AdditionalFilters };
export default AdditionalFilters;
